export default "__VITE_ASSET__BcNJs3MR__"